// src/pages/Docs.js
import React, { useState } from 'react';
import { FaListAlt, FaWater, FaBolt, FaSeedling } from 'react-icons/fa';

const Docs = () => {
    const [activeSection, setActiveSection] = useState("overview");

    const renderContent = () => {
        switch (activeSection) {
            case "overview":
                return (
                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2 flex items-center">
                            <FaListAlt className="text-yellow-400 mr-2" /> Overview
                        </h2>
                        <p className="text-gray-300 mb-2 text-sm sm:text-base">
                            These bots provide a comprehensive system for generating passive income in the Solana ecosystem. Through liquidity farming, token scalping, and stealthy coin launches, they create a scalable, automated process that maximizes profitability while maintaining an organic market presence.
                        </p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1 text-sm sm:text-base">
                            <li>Expected daily profit range: $2k to $15k, depending on market conditions.</li>
                            <li>Scalability: Bots can be scaled to handle more pairs, tokens, and launches.</li>
                        </ul>
                    </div>
                );
            case "raydium":
                return (
                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2 flex items-center">
                            <FaWater className="text-blue-400 mr-2" /> Raydium LP Farming Bot
                        </h2>
                        <p className="text-gray-300 mb-2 text-sm sm:text-base">
                            This bot capitalizes on high volatility in Raydium LPs, entering and exiting liquidity pools based on market conditions to generate passive income through strategic trades.
                        </p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1 text-sm sm:text-base">
                            <li>Automates entry and exit in liquidity pools</li>
                            <li>Targets high volatility pools for maximum yield</li>
                            <li>24/7 operation for continuous income</li>
                        </ul>
                    </div>
                );
            case "scalping":
                return (
                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2 flex items-center">
                            <FaBolt className="text-red-400 mr-2" /> Token Auto-Deployment & Profit Scalping Bot
                        </h2>
                        <p className="text-gray-300 mb-2 text-sm sm:text-base">
                            This bot automatically deploys $500-$600 into newly launched tokens, buys incrementally, and sells instantly when 100% profit is reached, reinvesting continuously for ongoing gains.
                        </p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1 text-sm sm:text-base">
                            <li>Automated token purchases and scalping at 100% profit</li>
                            <li>24/7 reinvestment for compounding gains</li>
                            <li>Continuous scanning for new profitable tokens</li>
                        </ul>
                    </div>
                );
            case "coinLaunch":
                return (
                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2 flex items-center">
                            <FaSeedling className="text-green-400 mr-2" /> Organic Coin Launch & Supply Acquisition Bot
                        </h2>
                        <p className="text-gray-300 mb-2 text-sm sm:text-base">
                            This bot launches new coins with a stealthy approach, buying up supply in an organic manner to attract buyers while maintaining market stability and interest.
                        </p>
                        <ul className="list-disc list-inside text-gray-300 space-y-1 text-sm sm:text-base">
                            <li>Stealthy coin launches to avoid detection</li>
                            <li>Supply control for demand stimulation</li>
                            <li>Organic-like buying behavior to attract real investors</li>
                        </ul>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="text-gray-200">
            {/* Header Section */}
            <section className="flex flex-col items-center text-center py-6 px-4 space-y-3">
                <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">Documentation</h1>
                <p className="text-gray-400 max-w-md text-sm sm:text-base mb-4">
                    Explore detailed information about each bot and how it works to maximize your passive income within the Solana ecosystem.
                </p>

                {/* Tabbed Navigation */}
                <div className="flex flex-wrap justify-center gap-2 mb-6">
                    {[
                        { section: "overview", label: "Overview", icon: <FaListAlt className="inline mr-1" /> },
                        { section: "raydium", label: "Raydium LP Farming Bot", icon: <FaWater className="inline mr-1" /> },
                        { section: "scalping", label: "Token Scalping Bot", icon: <FaBolt className="inline mr-1" /> },
                        { section: "coinLaunch", label: "Organic Coin Launch Bot", icon: <FaSeedling className="inline mr-1" /> },
                    ].map(({ section, label, icon }) => (
                        <button
                            key={section}
                            onClick={() => setActiveSection(section)}
                            className={`px-2 sm:px-3 py-1 rounded ${activeSection === section ? "bg-gray-800 text-white" : "text-gray-400 hover:bg-gray-700 hover:text-white"}`}
                        >
                            {icon} {label}
                        </button>
                    ))}
                </div>
            </section>

            {/* Main Content Section */}
            <section className="bg-gray-900 p-4 sm:p-6 rounded-lg shadow-lg max-w-2xl mx-auto mb-6">
                {renderContent()}
            </section>
        </div>
    );
};

export default Docs;
